export const SUCCESSFUL_PASSWORD_CHANGE_STRING = 'Password reset successfully';